import React from "react";
import { createContext, useContext, useState } from "react";
import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext'

export interface PermissionModel {
    Id: number;
    Code: string;
    Description: string;
    Area: string;
    CanCreate: boolean;
    CanEdit: boolean;
}

// Define the Permission context interface
interface PermissionContextProps {
    permission: PermissionModel[];   
}

const PermissionContext = createContext<PermissionContextProps>({} as PermissionContextProps);

// Export a hook to easily use the Permission context
export const usePermissionContext = (): PermissionContextProps => {
    const context = useContext(PermissionContext);    
    if (!context) {
        throw new Error("usePermissionContext must be used within a PermissionProvider");
    }
    return context;
};

interface PermissionProviderProps {
    children: React.ReactNode;
}

// Define the Permission provider
export const PermissionProvider: React.FC<PermissionProviderProps> = ({ children }) => {
    const [permission, setPermission] = useState<PermissionModel[]>([]);

    const axios = useAxios();

    // Load the permission from the API
    const loadPermission = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/api/Permissions/GetMyPermissions`);
            setPermission(response.data);
        } catch (error) {
            console.error(error);
        }
    }
React.useEffect(() => {
    loadPermission();
},[]);

return (
    <PermissionContext.Provider value={{ permission }}>
        {children}
    </PermissionContext.Provider>
);
};
